<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <br>
          <span class="arch">
            I hear the constant scratching of a pen. I think the sound it makes will travel between places and into my bones. I can feel the words as they're written.
            <span class="arch">
              <br>memories
              <br>are the
              <br>most
              <br>valuable
              <br>
              <br>
              <br>
              <br>things
              <br>
              <br>
              <br>
              <br>we
              <br>
              <br>
              <br>
              <br>
              <br>
              <br>
              <br>
              <br>have
              <br>
              <br>
              <br>There are things that should be preserved. There are ideas that should remain in the world and not cease. Preservation will mean that we aren't forgotten. Writing these words ensures their survival. Survival is . . .
              <br>
              Why is survival so important?
              <br>
              <br>
              I imagine the book in another place. A small thing, held in the hand and kept tightly closed. A pencil gripped in a tiny hand.
              <br>
              I can hear a child's voice, and it is asking for its father. It has a lilting voice, it is young.
              <br>
              I know that voice, and I cannot remember why. I want to hear it laugh, I want to see the smile that accompanies that sound.
              <br>
              It asks about the book. The words bound inside. More than a book, two books.
              <br>
              A hand writes in it, in each of them. Both of them.
              <br>
              And I imagine a mother, somewhere, not here. There are kettles on the stove behind her. I can see them steam.
              <br>Her face is lit by the light from a window in early morning. Mostly hidden in shadow and invisible, not there, but a play of warm yellow across a nose and cheek and under her eyelash.
              <br>How did I know her?
              <br>Thin hands, weathered from work, or from water, or both. Knotted together, a ring on one finger. Cracked fingernails.
              <br>Then another time, the same face, lit from one side, eyes closed in concentration. Long nose. Thin lips. Frowning.
              <br>A sheet of paper on the table in front of her. Typewritten. She is staring at it, or would be if her eyes were open.
              <br>Why do I know what colour those eyes are?
              <br>She has a bottle of black erasing fluid in her hand. It is closed, her fingers wrapped around the lid.
              <br>On the page, a collection of words.
              <br>She is writing something, has written something. Something significant, that reaches between two places.
              <br>
            </span>
          </span>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'A Writer'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
